import React, { Fragment, useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import logo from '../assets/favicon-black.png';
import './footer4.css'
import { Link } from 'react-router-dom';

const Footer4 = (props) => {
  const [userRole, setUserRole] = useState(null);
  
  useEffect(() => {
    const role = sessionStorage.getItem('userRole');
    setUserRole(role);
  }, []);
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-content">
          <div className="footer4-logo1">
            <img
              alt="KaamSaathi Logo"
              src={logo}
              className="footer4-logo2"
            />
          </div>
          <div className="footer4-links">
            <a
              href="/home"
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link1 ?? (
                <Link to="/home">
                  <span className="footer4-text18">Home</span>
                </Link>
              )}
            </a>
            <a
              href=""
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link2 ?? (
                <Fragment>
                  <span className="footer4-text17">About Us</span>
                </Fragment>
              )}
            </a>
            <a
              href=""
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link3 ?? (
                <Fragment>
                  <span className="footer4-text20">Contact</span>
                </Fragment>
              )}
            </a>
            <a
              href=""
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              
              {userRole === "Contractor" ? (
                <Link to='/subscriptions'>
                <span className="footer4-text21">Subscriptions</span>
              </Link>
              ): (
                <Link to='/labour-subscription'>
                <span className="footer4-text21">Subscriptions</span>
              </Link>
              )}
            </a>
          </div>
        </div>
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">© 2025 KaamSaathi</span>
            </div>
            <div className="footer4-footer-links">
              <span className="footer4-text11 thq-body-small">
                {props.privacyLink ?? (
                  <Fragment>
                    <span className="footer4-text16">Privacy Policy</span>
                  </Fragment>
                )}
              </span>
              <span className="thq-body-small">
                {props.termsLink ?? (
                  <Fragment>
                    <span className="footer4-text14">Terms and Conditions</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer4.defaultProps = {
  termsLink: undefined,
  link5: undefined,
  privacyLink: undefined,
  logoAlt: 'Job Portal Logo',
  link2: undefined,
  link1: undefined,
  logoSrc: 'https://presentation-website-assets.teleporthq.io/logos/logo.png',
  cookiesLink: undefined,
  link3: undefined,
  link4: undefined,
}

Footer4.propTypes = {
  termsLink: PropTypes.element,
  link5: PropTypes.element,
  privacyLink: PropTypes.element,
  logoAlt: PropTypes.string,
  link2: PropTypes.element,
  link1: PropTypes.element,
  logoSrc: PropTypes.string,
  cookiesLink: PropTypes.element,
  link3: PropTypes.element,
  link4: PropTypes.element,
}

export default Footer4
